import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkAccessFn } from "../../../../utils/checkAccess";
import { BiShow } from "react-icons/bi";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { CgSpinner } from "react-icons/cg";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { axios } from "../../../../Global";
import Highlighter from "react-highlight-words";

export default function ListDataContract({ list = [], titles = [], loading }) {
  const dashboardData = useSelector((state) => state.dashboardData);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const checkAccess = (module, name) => {
    return checkAccessFn(dashboardData, module, name);
  };

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await axios.get(`/dashboard/contract-download/excel`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Contract`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data ? list?.data : []);
  const commonItems = [{ label: "CONTRACT", link: "" }];
  useEffect(() => {
    dispatch(setBreadCrumb(commonItems));
  }, []);

  const [dataLoaded, setDataLoaded] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setDataLoaded(true);
    }, 2000);
  }, [list]);

  const [searchWords, setSearchWords] = useState([]);

  return (
    <>
      <div className="pt-2">
        <div className="flex flex-wrap  my-1 gap-3 items-center max-w-fit w-full">
          <Search
            searchKey={[
              "contract_number",
              "quotation.quotation_number",
              "client.name",
              "company.name",
              "start_date",
              "end_date",
            ]}
            setSearchWords={setSearchWords}
          />
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-xs flex items-center gap-2"
            onClick={() => downloadFile()}
            disabled={downloadLoading || list?.isLoading}
          >
            <p>Download</p>
            {downloadLoading && <CgSpinner className="animate-spin" />}
          </button>
        </div>
        <p className="text-sm w-full text-right font-medium mb-1  block">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div
          className={`grid grid-cols-table-contract auto-cols-min gap-5 p-6 bg-white   w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}
          {list?.isLoading && !dataLoaded && (
            <LoadingWithLable className="col-span-full" />
          )}
          {dataLoaded && <NoDataFound />}
          {!list?.isLoading &&
            currentList?.map((l, index) => (
              <React.Fragment key={index}>
                <PaginationIndex index={index} />
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={l?.contract_number || "--"}
                  />{" "}
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={l?.quotation?.quotation_number || "--"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={l?.client?.name || "--"}
                  />{" "}
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={l?.company?.name || "--"}
                  />{" "}
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={l?.contract_status || "--"}
                  />{" "}
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={l?.annexure_status || "--"}
                  />{" "}
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={l?.coc_attestation || "--"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={l?.start_date || "--"}
                  />{" "}
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={l?.end_date || "--"}
                  />{" "}
                </p>
                <div className="flex gap-3 min-w-fit ">
                  {checkAccess("Contract", "contract-list") ? (
                    <Link to={`${l.id}`}>
                      <button className="p-1 px-2 rounded-md ring-1 ring-slate-600">
                        <BiShow size={"1.4rem"} />
                      </button>
                    </Link>
                  ) : (
                    <button className="p-1 px-2 rounded-md ring-1 ring-slate-200">
                      --
                    </button>
                  )}
                </div>

                <hr className="border-[1.5px] border-slate-100  w-full col-span-full" />
              </React.Fragment>
            ))}
        </div>
        <Pagination />
      </div>
    </>
  );
}
